import { CustomFieldValue } from '../../../../../types/custom_field';
import { Lot } from '../../../../../types/lot';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

export enum PdfLotProperty {
  number = 'number',
  expirationDate = 'expirationDate',
}

export class PdfLotDataResolver extends PdfEntityDataResolver<Lot, PdfLotProperty> {
  properties = Object.values(PdfLotProperty);
  entityType = PdfFieldEntity.lot;

  getCustomFieldByEntity(entity: Lot, id: string): CustomFieldValue | undefined {
    return entity.customFields.get(id);
  }

  getLabelByProperty(property: PdfLotProperty): string {
    switch (property) {
      case PdfLotProperty.number:
        return 'Lot Number';
      case PdfLotProperty.expirationDate:
        return 'Expiration Date';
    }
  }

  getValueByProperty(property: PdfLotProperty, entity: Lot): string {
    switch (property) {
      case PdfLotProperty.number:
        return entity.number;
      case PdfLotProperty.expirationDate:
        return entity.expirationDate ? new Date(entity.expirationDate).toLocaleDateString() : '';
    }
  }
}
